const AppConfig = {
  appName: 'Ehonbook CMS'
}

export default AppConfig
